import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Select } from '@ngxs/store';
import { AddressPipe } from '@x/ecommerce-shop/app/core/address/pipes/address.pipe';
import { ShopOrderState } from '@x/ecommerce-shop/app/core/order/state/shop-order.state';
import { IShopOrder } from '@x/ecommerce/shop-client';
import { Observable } from 'rxjs';

@Component({
  selector: 'x-region-button',
  templateUrl: './region-button.component.html',
  styleUrls: ['./region-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AddressPipe],
  host: { class: 'x-region-button' },
})
export class RegionButtonComponent {
  @Select(ShopOrderState.order) shopOrder$: Observable<IShopOrder>;

  tooltip = $localize`:@@Region.EnterShippingAddress:Enter your shipping address to view all products available in your area.`;
}
